<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 11:12:26
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 11:15:36
 * @FilePath: \vue-privilege-routing\src\pages\component\archives\index.vue
-->
<template>
    <div>
       档案模组
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
